import { cB } from '../../../_utils/cssr';
// --n-menu-box-shadow
export default cB('popselect-menu', `
 box-shadow: var(--n-menu-box-shadow);
`);